import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { GetOverdueTaskReportApi } from "../../../api/request/reports/report.js";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/reports/activeJobReport.js";
import { GetTeamMemberListApi } from "../../../api/request/team/team.js";

const OverdueJobTask = () => {
  const [OverdueTaskReport, setOverdueTaskReportList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getOverdueTaskReportList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetOverdueTaskReportApi();
      if (data?.status) {
        setOverdueTaskReportList(
          data?.data?.map((item) => {
            return {
              ...item,
              organizer: (
                <div className="font-bold highlight-text capitalize">
                  {item?.organizer?.organizer_name_slug}
                </div>
              ),
              name: item?.users?.name,
              email: item?.users?.email,
              task_name: item?.task_master?.name,
              assignTo: item?.employee?.name,
              startDate: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              status: (
                <p className="text-green-500 font-bold uppercase">
                  {item?.status}
                </p>
              ),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setOverdueTaskReportList([]);
      setIsLoading(false);
    }
  };

  const getEmployeeList = async () => {
    setIsLoading(true);
    try {
      const { data } = await GetTeamMemberListApi();
      if (data.status) {
        columns.map((item) => {
          if (item.dataIndex === "assignTo") {
            item.filters = data?.data?.map((item) => {
              return { text: item?.name, value: item?.name };
            });
          }
        });
      }
    } catch (error) {
      setIsLoading(false);
    }finally{
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getOverdueTaskReportList();
    getEmployeeList();
  }, []);

  return (
    <div className="border-2 rounded-xl my-5">
      <div className="flex justify-between mx-5 mt-5">
        <p className=" font-semibold text-2xl">Overdue Task Reports</p>
      </div>
      <div className="my-6">
        <SkeletonTable
          columns={columns}
          searchingFields={["name", "email"]}
          dateFilterFields={["startDate"]}
          data={OverdueTaskReport}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default OverdueJobTask;
